import gCard from "@/components/g-card/g-card.vue";
import gButton from "@/components/g-button/g-button.vue";
import gForm from "@/components/g-form/g-form.vue";
import gDataTable from "@/components/g-data-table/g-data-table.vue";
import AccountLoged from "@/shared/mixins/AccountLoged";
import CondicoesPagamentoController from "@/shared/controllers/condicoesPagamento/condicoesPagamentoController";
import CondicoesPagamentoViewModel from "@/shared/view-models/Filtros/FormaPagamentoViewModel"
import { defineComponent } from "vue";

const name = 'GerenciamentoCondicoesPagamento'

export default defineComponent({
  name,

  components: {
    "g-card": gCard,
    "g-button": gButton,
    "g-form": gForm,
    'g-data-table': gDataTable
  }, 

  props: { },
  mixins:[AccountLoged],

  mounted () {
    if(!this.hasClaim('Gerenciamento-Condições de Pagamento')) {
      this.$router.push('/sem-acesso')
    }
    this.GetCondicoesPagamentoByFiltro();
    this.condViewModel.OpcaoAtivo = 0
  },

  updated () { },

  data () {
    return {
      CondicoesPagArray: [],
      mensagemvazio: false,
      AtivoArray: [
        {opcoes: "Ambos", value: 0 },
        {opcoes: "Não-Ativo", value: 1 },
        {opcoes: "Ativo", value: 2 },
      ],
      formaPagamentoSelecionadaId: '',
      condViewModel: new CondicoesPagamentoViewModel(),
      indexSelecionado: -1,
      popup: false,
      Atividade: true,
      Colunas: [
        { field: "formaDePagamento", header: "Forma de Pagamento", ordena: true },
        { field: "porcentagemFinanceira", header: "Porcentagem Financeira", ordena: true },
        { field: "prazoMedio", header: "Prazo Médio", ordena: true },
        { field: "ativoTexto", header: "Ativo", ordena: true },
      ],
      Filtro: {
        'global': {value: null, matchMode: this.filtros.CONTAINS},
        'formaDePagamento': {value: null, matchMode: this.filtros.CONTAINS},
        'porcentagemFinanceira': {value: null, matchMode: this.filtros.CONTAINS},
        'prazoMedio': {value: null, matchMode: this.filtros.CONTAINS},
        'ativoTexto': {value: null, matchMode: this.filtros.CONTAINS},
      },
    }
  },

  methods: {    
    limpar() {
      this.condViewModel = new CondicoesPagamentoViewModel;
    },
    retornaTelaMinhaArea() {
      this.$router.push(`/dashboard`)
    },

    GetCondicoesPagamentoByFiltro() {
      this.$isLoading(true)
      CondicoesPagamentoController.GetCondicoesPagamentoByFiltro(this.condViewModel).requisicao
      .then(response => {
        this.CondicoesPagArray = response.data.data
      })
      .finally(this.$isLoading(false))
    },

    abrirPopupAtivo(data, index) {
      this.popup = true
      this.indexSelecionado = index;
      this.formaPagamentoSelecionadaId = data.id
      this.Atividade = !data.excluido
    },
    fecharPopup() {
      this.popup = false
    },

    inativaFormaPagamento() {
      CondicoesPagamentoController.InativaFormaPagamento(this.formaPagamentoSelecionadaId, this.Atividade).requisicao
      .then(res => {
        if(res.data.data){
          this.CondicoesPagArray[this.indexSelecionado].excluido = !this.Atividade;
          this.CondicoesPagArray[this.indexSelecionado].ativoTexto = this.Atividade ? 'Sim' : 'Não'
          this.$toast.add({ severity: 'success', summary: 'Alteração concluída', detail: 'O status de atividade da condição de pagamento foi alterado com sucesso!', life: 5000 });
          this.popup = false
        }
        else{
          this.$toast.add({ severity: 'error', summary: 'Alteração não concluída', detail: 'Houve um erro ao tentar alterar o status de atividade da condição de pagamento.', life: 5000 });
          this.popup = false
        }
      })
    }
  },

  computed: { }, 
});